import React from 'react'
import PropTypes from 'prop-types'

import Channel from './Channel'

export default class Container extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        initialInherited: PropTypes.number,
    }

    static defaultProps = {
        initialInherited: 0,
    }

    static contextTypes = {
        'sticky-channel': PropTypes.any,
    }

    static childContextTypes = {
        'sticky-channel': PropTypes.any,
    }

    constructor(props) {
        super(props)
        this.channel = new Channel({
            inherited: props.initialInherited,
            offset: 0,
            node: null,
        })
    }

    getChildContext() {
        return { 'sticky-channel': this.channel }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.initialInherited !== this.props.initialInherited) {
            this.channel.update((data) => { data.inherited = nextProps.initialInherited })
        }
    }

    componentWillMount() {
        const parentChannel = this.context['sticky-channel']
        if (parentChannel) parentChannel.subscribe(this.updateOffset)
    }

    componentDidMount() {
        this.channel.update((data) => { data.node = this._node })
    }

    componentWillUnmount() {
        this.channel.update((data) => { data.node = null })

        const parentChannel = this.context['sticky-channel']
        if (parentChannel) parentChannel.unsubscribe(this.updateOffset)
    }

    updateOffset = ({ inherited, offset }) => {
        this.channel.update((data) => { data.inherited = inherited + offset })
    }

    render() {
        return (
            <div ref={(c) => { this._node = c }}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../node_modules/react-wot-bootstrap/lib/components/Sticky/Container.jsx